import styles from "./HighlightedText.module.css";

interface HighlightedTextProps {
  text?: string | null;
  highlight?: string | null;
}

const HighlightedText = ({ text, highlight }: HighlightedTextProps) => {
  const fragments = text
    ?.split(new RegExp(`(${highlight})`, "gi"))
    .map((fragment, index) => {
      return fragment.toLowerCase() === highlight?.toLowerCase() ? (
        <mark className={styles.highlight} key={index}>
          {fragment}
        </mark>
      ) : (
        fragment
      );
    });

  return <>{highlight ? fragments : text}</>;
};

export default HighlightedText;
